const css = `._chip_v2qni_1 {
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  color: var(--text-color);
  cursor: default;
  display: inherit;
  direction: ltr;
  font-size: 0.8em;
  justify-content: center;
  padding: 8px;
  text-align: center;
  white-space: nowrap;
}
._chip_v2qni_1._small_v2qni_15 {
  font-size: 0.8em;
  padding: 4px;
}
._chip_v2qni_1._medium_v2qni_19 {
  font-size: 1em;
  padding: 8px;
}
._chip_v2qni_1._large_v2qni_23 {
  font-size: 1.2em;
  padding: 16px;
}
@media (max-width: 767px) {
  ._chip_v2qni_1._small_v2qni_15, ._chip_v2qni_1._medium_v2qni_19, ._chip_v2qni_1._large_v2qni_23 {
    padding: 4px;
  }
}
._chip_v2qni_1[data-chip-type=borderless] {
  padding: 0;
}

button._chip_v2qni_1 {
  cursor: pointer;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "chip": "_chip_v2qni_1",
  "small": "_small_v2qni_15",
  "medium": "_medium_v2qni_19",
  "large": "_large_v2qni_23"
};